import {
	Box,
	Button,
	IconButton,
	Link,
	makeStyles,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import CustomModal from "common/components/CustomModal/CustomModal";
import {
	ModalBody,
	ModalHeader,
	ModalPanel,
} from "common/components/CustomModal/Modal/ModalFrame";
import { LocalStorageKeys } from "common/constants/StorageKeys";
import ModalHelper from "common/helpers/modalHelper";
import React from "react";

const MOBILE_APP_URL = "https://mobile.pickstop.gg/";

const useStyles = makeStyles({
	panel: {
		"&&": {
			position: "relative",
			paddingLeft: 36,
			paddingRight: 36,
			width: "calc(100vw - 48px)",
			maxWidth: 600,
			boxSizing: "border-box",
		},
	},
	closeButton: {
		position: "absolute",
		top: 8,
		right: 8,
		color: "#ececec",
	},
	header: {
		"& h3": {
			lineHeight: 1.3,
		},
	},
	body: {
		textAlign: "center",
		fontSize: 17,
	},
	buttonRow: {
		paddingTop: 20,
		paddingBottom: 14,
	},
	noThanksLink: {
		color: "#b9b8b8",
		cursor: "pointer",
		fontSize: 14,
	},
});

export default function NewExperienceModal() {
	const styles = useStyles();

	const onTakeMeThere = () => {
		window.location.href = MOBILE_APP_URL;
	};

	const onNoThanks = () => {
		localStorage.setItem(LocalStorageKeys.STAY_ON_LEGACY, "1");
		ModalHelper.closeModal();
	};

	const onClose = () => {
		ModalHelper.closeModal();
	};

	return (
		<CustomModal>
			<ModalPanel className={styles.panel}>
				<IconButton
					className={styles.closeButton}
					onClick={onClose}
					size="small"
					aria-label="Close"
				>
					<Close />
				</IconButton>
				<ModalHeader className={styles.header}>
					Try the new Pickstop mobile experience
				</ModalHeader>
				<ModalBody className={styles.body}>
					We've built a new version made for mobile. Want to try it?
				</ModalBody>
				<Box
					className={styles.buttonRow}
					display="flex"
					justifyContent="space-between"
					alignItems="center"
				>
					<Link
						className={styles.noThanksLink}
						component="button"
						underline="always"
						onClick={onNoThanks}
					>
						No thanks, stay here
					</Link>
					<Button variant="contained" color="primary" onClick={onTakeMeThere}>
						Take me there
					</Button>
				</Box>
			</ModalPanel>
		</CustomModal>
	);
}
